"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Svg = _interopRequireDefault(require("./new-components/Svg/Svg"));
var _constants = require("./new-components/constants");
var LoadingView = function LoadingView(_ref) {
  var title = _ref.title,
    icon = _ref.icon,
    className = _ref.className,
    fill = _ref.fill;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      color: '#182c4b',
      textAlign: 'center',
      padding: 100
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: icon || 'sea-transport-wheel',
    className: className || 'd8-u-spinreverse-animation icon--lg',
    fill: fill || _constants.COLORS.PRIMARY
  })), /*#__PURE__*/_react["default"].createElement("h1", {
    className: "m-t-lg"
  }, title || 'Aligning the stars...'));
};
LoadingView.propTypes = {
  title: _propTypes["default"].string,
  icon: _propTypes["default"].string,
  className: _propTypes["default"].string,
  fill: _propTypes["default"].string
};
var _default = exports["default"] = LoadingView;